import React from 'react';
import { Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import State from '../states/State';
import useStyles from '../styles/styles';
import { change } from 'redux-form';
import { formName } from '../thunks/constants'

type ButtonAttribute = {
  readonly label: string,
  readonly link?: string,
}

type PeMoreInfoProps = {
  readonly label: string,
  readonly button?: ButtonAttribute,
  readonly type?: string,
  readonly initValue?: string,
  readonly source?: string,
  readonly name?: string,
  readonly headTitle?: string,
}

const PeMoreInfo: React.FC<PeMoreInfoProps> = ({ type, label, initValue, source, button, name, headTitle }) => {
  const classes = useStyles();
  const state = useSelector((state: State) => ({
    shell: state.shell,
  }));

  const dispatch = useDispatch();
  const { notes } = state.shell.templates;

  let classType = type && type === 'warn' ? classes.warn : type === 'notice' ? classes.notice : classes.PeMoreInfo_info;

  const renderContent = () => {
    let content = label;
    if (initValue) {
      // get content from source
      switch (source) {
        case 'note':
          Object.keys(notes).forEach((key: any) => {
            if (notes[key].title === initValue) {
              content = notes[key].content;
            }
          });
          break;
        default:
          break;
      }
    }
    return content;
  }

  React.useEffect(()=>{
    if (initValue && source === 'note') {
      // dispatch to form value
      dispatch(change(formName, 'pe_note', renderContent())); 
    } // eslint-disable-next-line
  }, [initValue, source, dispatch]);

  return <div>
      {headTitle && <h3 className={classes.label} style={{padding: '16px 16px 0 16px'}}>{headTitle}</h3>}
      <div id={name && `node_${name}`} className={classes.PeMoreInfo_control + ' ' + classType}>
        {renderContent()}
        {button && <div className={classes.buttonArea}>
          <Button className={classes.PeMoreInfo_button} variant="contained" size="small">{button?.label}</Button>
        </div>}
      </div>
    </div>
}

export default PeMoreInfo;